// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NWf8ABCVmdEgHn_DezIm{border-radius:12px;padding:8px}.AgEmCKq5lFQbATxkjhp0{width:100%}.j1K9KHXKykILAF5eQQC9{border:1px solid var(--interaction-neutral-normal);border-radius:6px;justify-content:space-between;align-items:center;gap:8px;min-height:40px;margin-top:16px;padding:3px 7px 3px 11px;display:flex}.j1K9KHXKykILAF5eQQC9.hZ58O5uOQFwXrHx8kN92{cursor:pointer;width:100%;margin-top:0;padding:8px 8px 8px 12px}.j1K9KHXKykILAF5eQQC9 .YobJtInUV3w2pcB5L2L2{border-radius:100%;width:20px;height:20px}.j1K9KHXKykILAF5eQQC9 .hQjtPE_NZVYWeynur1Fp{width:100px}.pfg_1sYk0R0KxNdgqs_D{box-shadow:inset 0 0 0 1px var(--interaction-brand-active),0 0 0 3px var(--background-brand-subtle)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colorPickerContainer": `NWf8ABCVmdEgHn_DezIm`,
	"colorPickerDropdown": `AgEmCKq5lFQbATxkjhp0`,
	"colorPickerInput": `j1K9KHXKykILAF5eQQC9`,
	"trigger": `hZ58O5uOQFwXrHx8kN92`,
	"color": `YobJtInUV3w2pcB5L2L2`,
	"colorPickerColorInput": `hQjtPE_NZVYWeynur1Fp`,
	"colorPickerInput_focused": `pfg_1sYk0R0KxNdgqs_D`,
	"colorPickerInputFocused": `pfg_1sYk0R0KxNdgqs_D`
};
export default ___CSS_LOADER_EXPORT___;
